import { productApi, useLazyProductFullInfoQuery, usePrefetchProduct } from '@entities/product/api/product-api';
import { ProductShortInfoDataRequest } from '@entities/product/api/product-types';
import { useSharedQueryTriggerStatus } from '@shared/lib/hooks/use-shared-query-trigger-status/use-shared-query-trigger-status';

/* 
    Позволяет шарить результат useLazyQuery между разными компонентами, использующими useSharedQuery
    При обновлении  результата useLazyQuery происходит обновление всех зависимых компонентов
*/
export const useProductFullInfoSharedQuery = (parameters?: ProductShortInfoDataRequest) => {
    const { setTriggerStatus } = useSharedQueryTriggerStatus();
    const [queryTrigger] = useLazyProductFullInfoQuery();
    const queryResult = productApi.endpoints.productFullInfo.useQueryState(parameters!, { skip: !parameters });
    const preferchCatalogInfo = usePrefetchProduct('productFullInfo', { ifOlderThan: 60 });

    const handlePrefetch = () => {
        parameters && preferchCatalogInfo(parameters);
    };

    const handleTrigger = async (args: ProductShortInfoDataRequest, isCache = true) => {
        setTriggerStatus('pending');
        const result = await queryTrigger(args, isCache);
        setTriggerStatus('completed');
        return result;
    };

    return [handleTrigger, queryResult, handlePrefetch] as const;
};
